module.exports = "/img/_/_/_/assets/images/creeper/battle/common//28.jpg?8aa71350e494d58d882225855234d378";